import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import CustomNavbar from "../CustomPermissions/CustomNavbar";

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../../config/api";

const CreateRecord = () => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    password: "",
    username: "",
    resume_forwarded: 0,
    pipline: 0,
    selected: 0,
    target: 0,
    turned_up: 0,
    image: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFormData({ ...formData, image: file });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      formDataToSend.append(key, formData[key]);
    });

    try {
      await axios.post(getApiUrl("/Docladder/create_Teammember_api/"), formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      });
      navigate("/records"); // Redirect on success
    } catch (error) {
      if (error.response && error.response.data) {
        const errorData = error.response.data;
        
        // Check if there's a single error message
        if (errorData.error || errorData.message) {
          setErrorMessage(errorData.error || errorData.message);
        } else {
          // Handle multiple field errors
          const errorMessages = Object.keys(errorData)
            .map((key) => {
              const value = errorData[key];
              // Check if value is an array
              if (Array.isArray(value)) {
                return `${key}: ${value.join(", ")}`;
              }
              // If it's a string or other type
              return `${key}: ${value}`;
            })
            .join("\n");
          setErrorMessage(errorMessages);
        }
      } else {
        setErrorMessage("An unexpected error occurred.");
      }
    }
  };

  return (
    <>
      <div style={{ display: "flex" }}>
        <CustomNavbar />
        <div
          style={{
            width: "100vw",
            maxHeight: "100vh",
            overflowY: "scroll",
            marginBottom: "15px",
            paddingBottom: "30px",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "70px",
              background: "var(--bg-blue)",
            }}
          >
            <h3
              style={{
                color: "white",
                paddingTop: "15px",
                paddingLeft: "25px",
              }}
            >
              Add HR Associate
            </h3>
          </div>
          {errorMessage && (
            <div className="bg-red-200 text-blue-700 border border-red-600 px-4 py-3 rounded-md my-4">
              {errorMessage}
            </div>
          )}
          <div
            className="container mx-auto"
            style={{ width: "90%", margin: "auto", marginTop: "35px" }}
          >
            <div
              className="container"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <Link
                to="/records"
                style={{
                  marginTop: "8px",
                  border: "1px solid blue",
                  padding: "15px",
                  borderRadius: "7px 15px",
                  background: "var(--bg-blue)",
                  color: "white",
                }}
              >
                All Records
              </Link>
            </div>

            <form
              onSubmit={handleSubmit}
              method="post"
              encType="multipart/form-data"
              style={{ marginTop: "20px" }}
            >
              <div
                className="grid"
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)",
                  gap: "20px",
                }}
              >
                {[
                  { label: "Name", name: "name", type: "text" },
                  { label: "Username", name: "username", type: "text" },
                  { label: "Password", name: "password", type: "password" },
                  {
                    label: "Resumes Forwarded",
                    name: "resume_forwarded",
                    type: "number",
                  },
                  { label: "Pipeline", name: "pipline", type: "number" },
                  { label: "Turned Up", name: "turned_up", type: "number" },
                  { label: "Selected", name: "selected", type: "number" },
                  { label: "Target", name: "target", type: "number" },
                  { label: "Upload Image", name: "image", type: "file" },
                ].map((field, index) => (
                  <div key={index}>
                    <label
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      htmlFor={field.name}
                    >
                      {field.label}
                    </label>
                    <input
                      className="block w-full px-4 py-2 text-sm text-gray-700 bg-white border rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
                      id={field.name}
                      name={field.name}
                      type={field.type}
                      value={
                        field.type !== "file" ? formData[field.name] : undefined
                      }
                      onChange={
                        field.type !== "file" ? handleChange : handleImageChange
                      }
                      required
                    />
                  </div>
                ))}
              </div>

              <div className="flex justify-end mt-4">
                <button
                  type="submit"
                  className="px-4 py-2 text-sm font-medium text-white bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none focus:ring"
                  style={{ background: "var(--bg-blue)" }}
                >
                  Create
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateRecord;
